module.exports = __webpack_public_path__ + "assets/img/dishes4.dd91e488.png";